import { Injectable, Injector } from '@angular/core';
import { RouterState, RoutingService } from '@spartacus/core';
import { map } from 'rxjs/operators';
import { ProductListAnalyticsService } from './product-list-analytics.service';

@Injectable({ providedIn: 'root' })
export class CmsProductCardAnalyticsService extends ProductListAnalyticsService {
  constructor(
    private routingService: RoutingService,
    injector: Injector,
  ) {
    super(injector);
    this.setAnalyticsListName();
  }

  private setAnalyticsListName(): void {
    this.subscription.add(
      this.routingService
        .getRouterState()
        .pipe(
          map((routerState: RouterState) => {
            switch (routerState.state.semanticRoute) {
              case 'home': {
                return 'Главная';
              }

              default:
                return '';
            }
          }),
        )
        .subscribe(this.analyticsListName$),
    );
  }
}
